import { useEffect, useMemo } from 'react';

import { useAuthentication } from '@givebacks/api';
import { usePlatformService } from 'core/Hooks';
import { BASE_URL } from 'core/Utils';
import { Outlet, useLocation, useNavigate, useOutletContext } from 'react-router-dom';

import { APP_LINKS, MOBILE_ROUTES } from '../../utils/enums';

type InAppShortSessionsLayoutContext = {
  closeNativeBrowser: (from: string, exitStatus: number, action: string) => void;
};

interface MessageFromWeb {
  location?: string;
  status: 200 | 500 | 401;
  action?: 'data' | 'close';
}

export const InAppShortSessionsLayout = (): JSX.Element => {
  const Platform = usePlatformService();
  const { isAuthenticated } = useAuthentication();
  const navigate = useNavigate();
  const location = useLocation();
  const nextRoute = useMemo(() => location.pathname, [navigate]);

  const closeNativeBrowser = (
    from: MessageFromWeb['location'],
    exitStatus: MessageFromWeb['status'],
    action?: MessageFromWeb['action']
  ) => {
    if (Platform.mobileBrowser == 'ios') {
      window.location.href = `${BASE_URL}${MOBILE_ROUTES.native}?location=${from}&status=${exitStatus}&action=${action}`;
      window.open(
        `${BASE_URL}${MOBILE_ROUTES.native}?location=${from}&status=${exitStatus}&action=${action}`
      );
    } else {
      window.open(
        `${APP_LINKS.android_scheme}?location=${from}&status=${exitStatus}&action=${action}`
      );
    }
  };

  useEffect(() => {
    // navigate(nextRoute, { replace: true }); instead of this, lets ust remove the token from the search paramm in the container...
    if (!isAuthenticated) {
      closeNativeBrowser(nextRoute || '', 401);
      navigate('/', { replace: true });
    }
  }, [isAuthenticated]);

  return <Outlet context={{ closeNativeBrowser }} />;
};

export function useInAppShortSessionsLayoutContextLayout() {
  return useOutletContext<InAppShortSessionsLayoutContext>();
}
